import { Switch, Route, withRouter } from 'react-router-dom';
import CenterAdmin from '@nkr/views/center-admin';
import { editNavKey } from '@nkr/views/recipients/profile/models';

const CenterRecipientRoutes = (params) => {
    let url = params.url;

    return (
        <Switch>
            {/* <Route exact path={`${url}/voucher-holder/:voucherHolderId`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} section='VOUCHER-HOLDER-EDIT' voucherHolderId={subParams.voucherHolderId} />} /> */}

            <Route exact path={`${url}/:recipientId/potential-donors`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='POTENTIAL-DONORS' itemId={subParams.recipientId} />} />

            <Route exact path={`${url}/:recipientId/rs-enroll`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='RS-ENROLL' itemId={subParams.recipientId} />} />

            <Route exact path={`${url}/:recipientId/waitlist-replace`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='WAITLIST-REPLACE' itemId={subParams.recipientId} />} />

            <Route exact path={`${url}/:recipientId/rexm/:rexmId`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} section='RECIPIENTS' subSection='EVALUATE-REXM' centerId={params.id} itemId={subParams.rexmId} />} />

            <Route exact path={`${url}/:recipientId/evaluate-donor/:donorId`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} section='RECIPIENTS' subSection='EVALUATE-DONOR' centerId={params.id} />} />

            <Route exact path={`${url}/:recipientId/evaluate-match/:donorId`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} section='RECIPIENTS' subSection='EVALUATE-RECIPIENT-DONOR' centerId={params.id} />} />

            <Route exact path={`${url}/evaluate-match/:matchHistoryId`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} section='RECIPIENTS' subSection='EVALUATE-MATCH' centerId={params.id} itemId={subParams.matchHistoryId} />} />

            {/* <Route exact path={`${url}/:recipientId/profile/antibody-screening`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection='ANTIBODY-SCREENING' />
            } /> */}

            <Route exact path={`${url}/:recipientId/profile/`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.GENERAL} />
            } />

            <Route exact path={`${url}/:recipientId/profile/general`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.GENERAL} />
            } />

            <Route exact path={`${url}/:recipientId/profile/contact-info`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.CONTACT_INFORMATION} />
            } />

            <Route exact path={`${url}/:recipientId/profile/med-details`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.MEDICAL_DETAILS} />
            } />

            <Route exact path={`${url}/:recipientId/profile/hla-info`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.HLA_INFORMATION} />
            } />

            <Route exact path={`${url}/:recipientId/profile/records`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.RECORDS} />
            } />

            <Route exact path={`${url}/:recipientId/profile/fin-info`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.FINANCIAL_INFORMATION} />
            } />

            <Route exact path={`${url}/:recipientId/profile/activity-log`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.ACTIVITY_LOG} />
            } />

            <Route exact path={`${url}/:recipientId/profile/donor-declines`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.DONOR_DECLINES} />
            } />

            <Route exact path={`${url}/:recipientId/profile/post-transplant`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.POST_TRANSPLANT} />
            } />

            <Route exact path={`${url}/:recipientId/profile/paired-donors`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.PAIRED_DONORS} />
            } />

            <Route exact path={`${url}/:recipientId/profile/antibody-screening`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} recipientId={subParams.recipientId} section='RECIPIENTS' subSection='RECIPIENT-PROFILE' tertiarySection={editNavKey.ANTIBODY_SCREENINGS} />
            } />

            <Route exact path={`${url}/:recipientId/toolbox`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='TOOLBOX' itemId={subParams.recipientId} />} />

            <Route exact path={`${url}/:recipientId/donor-fact-sheet/:donorId`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='DONOR-FACT-SHEET' itemId={subParams.recipientId} />} />

            <Route exact path={`${url}/:recipientId/eplet-mm/:donorId`} render={({ match: { params: subParams } }) =>
                <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='EPLET-MM' itemId={subParams.recipientId} />} />
        </Switch>
    );
}

export default withRouter(CenterRecipientRoutes);